module.exports = __webpack_public_path__ + "img/flower.9ca459dd.png";